export default __webpack_public_path__ + "static/media/art1.bf31aedb.mp4";